import ModuleBase, { ViewLayer, moduleInit, bindButtonClickEvent, implementFunction } from "../../../../framework/core/mvvm/module_base";
import FriendView from "./friend_view";
import LanguageManager from "../../../../manager/language_manager";
import ModuleManager from "../../../../framework/core/module_manager";
import ModelData, { IUserData } from "../../../public/model_data";
import { friend_utils } from "./friend_utils";
import { IUserCurrencyData } from "../../../../manager/user_manager";

const {ccclass, property} = cc._decorator;

@ccclass
@moduleInit("FriendModule")
export default class FriendModule extends ModuleBase<FriendView,null> {

    private currency : number ;

    constructor(){
        super();

        this.layer = ViewLayer.Mid;
        this.modelType = null;
        this.viewType = FriendView;
        this.needAnim = true;
        this.autoShowAnim = true
        this.needViewMask = true
        this.clickAnywhereClose = true;
        this.needViewBaseCloseBtn = true;
        this.needViewBaseTitleBg = true
        this.needViewBaseBg = true
        this.windowPrefabResPath = "package/hall/module/friend/friend"
        
    }

    onLoad(){
        this.eventBind("request_add_friend",this.on_request_add_friend);
        this.eventBind("request_agree_apply",this.on_request_agree_apply);
        this.eventBind("request_remove_apply",this.on_request_remove_apply);
        this.eventBind("request_chat_friend",this.on_request_chat_friend);
        this.eventBind("friend_list_do_action",this.on_friend_list_do_action);
    }

    onShow(){
        
    }

    private on_request_add_friend(friendId : number){

        friend_utils.addFriend(friendId,this,(result : boolean)=>{

            if (result) {
                
                //弹出申请成功提示                            
                let content = LanguageManager.t("friend_add_friend_success");

                ModuleManager.instance.toast(content);
            }            

            this.view.searchItem.node.active = false;
        });
    
    }

    private on_request_agree_apply(index : number){

        let data = this.view.inviteList[index];
        this.reqConfirmAdd(index,data.friendId);
            
    }

    private on_request_remove_apply(index : number){

        let data = this.view.inviteList[index];
        this.reqRemoveInvite(index,data.friendId);
    }

    private on_request_chat_friend(index : number){

        let data = this.view.friendList[index];
        ModuleManager.instance.showModuleName("Chat",{ friendId : data.friendId, chatHideCallback :  this.onChatHide.bind(this)});

        this.node.active = false
        // this.hide();
    }

    private onChatHide() {
        this.node.active = true
    }



    @implementFunction('onSelfCurrencyDataUpdate')
    protected on_selfCurrencyDataUpdate(data: IUserCurrencyData) {
        
        this.currency = data.chip;
        
        this.view.updateCurrency(this.currency);

        
        //this.view.transCom.updateCurrency(this.currency);


    }

   

    private on_friend_list_do_action(){

        this.getSelfCurrencyData();

    }

  
    @bindButtonClickEvent("close")
    onClose(){
        this.hide();
    }


    onHide(){

        this.view.searchItem.node.active = false;
    }
  

    @bindButtonClickEvent("serach_button")
    onSearch(){
        let searchId = Number(this.view.serachEditBox.string);

        this.view.searchItem.node.active = false;

        //是否为自己
        if (searchId == ModelData.instance.roleData.id) {                        
            //不能添加自己
            ModuleManager.instance.toast(LanguageManager.t("friend_add_add_self_tip"));
            return;
        }

        //判断 此人是否在好友列表、邀请列表中
        friend_utils.isFriend(searchId,this,(result)=>{

            if (result) {                
                ModuleManager.instance.toast(LanguageManager.t("friend_add_in_friendlist"));
                //console.log("此人已在好友列表中");
            }else{

                friend_utils.isInvite(searchId,this,(inviteResult)=>{

                    if (inviteResult) {
                        ModuleManager.instance.toast(LanguageManager.t("friend_add_in_invitelist"));
                        //console.log("此人已在申请列表中");
                    }else{
                        this.reqSearch(searchId,true);
                    }
                })
            }

        });

    }

    private reqSearch(friendId : number,popTips : boolean = false){

        //检测id合法性
        let requestData : IHttpRequestData = {
            baseUrl: "user/otherInfo?",
            params: {
                otherUserId : friendId,
            }
        }

        let self = this;

        this.apiHttpGet(requestData,(response)=>{

            if (response.code != 'SUCCESS' || !response.data) {
                
                ModuleManager.instance.toast(LanguageManager.t("friend_add_friend_id_error"));

            }else{

                //显示此人信息
                self.view.searchItem.updateInfo(response.data);    
                
                self.view.serachEditBox.string = "";
            }
    
        });
        
    }

    private reqConfirmAdd(index : number,friendId : number){

        let requestData : IHttpRequestData = {

            baseUrl : 'friendship/confirmFriend?',
            params : {
                friendId : friendId
            },
            showNetPrompt : true,
        }
        let self = this;
        this.apiHttpGet(requestData,(response)=>{

            console.log(" confirmFriend data : " , response);
            if (response.code == 'SUCCESS' && response.data) {   
                
                self.view.requestInvite();
                //self.view.removeItem(index);
            }
        });
    }

    private reqRemoveInvite(index : number,friendId : number){

        let requestData : IHttpRequestData = {

            baseUrl : 'friendship/deleteFriendInvite?',
            params : {
                friendId : friendId
            },

            showNetPrompt : true,
        }
        let self = this;
        this.apiHttpGet(requestData,(response)=>{

            console.log(" deleteFriendInvite data : " , response);
            if (response.code == 'SUCCESS' && response.data) {   

                //self.view.removeItem(index);
                self.view.requestInvite();
            }
        });

    }
}
